import React, { useState, useEffect, useCallback } from 'react';
import {
  Form, Input, Button, Card, Row, Col, message, Space, Typography,
} from 'antd';
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api/axios';

const { Title } = Typography;
const { TextArea } = Input;

const AramaForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const fetchData = useCallback(async () => {
    if (!isEdit) return;
    setLoading(true);
    try {
      const res = await api.get(`/aramalar/${id}`);
      const item = res.data.data || res.data;
      form.setFieldsValue(item);
    } catch {
      message.error('Kayıt yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, [id, isEdit, form]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const onFinish = async (values) => {
    setSaving(true);
    try {
      if (isEdit) {
        await api.put(`/aramalar/${id}`, values);
        message.success('Kayıt güncellendi');
      } else {
        await api.post('/aramalar', values);
        message.success('Arama kaydı eklendi');
      }
      navigate('/aramalar');
    } catch (err) {
      message.error(err.response?.data?.message || 'Kayıt başarısız');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/aramalar')}>Geri</Button>
            <Title level={4} style={{ margin: 0 }}>
              {isEdit ? 'Arama Kaydı Düzenle' : 'Yeni Arama Kaydı'}
            </Title>
          </Space>
        </Col>
      </Row>

      <Card className="content-card" style={{ maxWidth: 640 }} loading={loading}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="arayanAdi"
            label="Arayan Adı Soyadı"
            rules={[{ required: true, message: 'Ad soyad zorunludur' }]}
          >
            <Input placeholder="Ad soyad girin" size="large" />
          </Form.Item>

          <Form.Item
            name="telefon"
            label="Telefon"
            rules={[{ required: true, message: 'Telefon zorunludur' }]}
          >
            <Input placeholder="05xx xxx xxxx" size="large" />
          </Form.Item>

          <Form.Item
            name="aramaSebebi"
            label="Arama Sebebi / Açıklama"
            rules={[{ required: true, message: 'Arama sebebi zorunludur' }]}
          >
            <TextArea
              rows={5}
              placeholder="Aramanın sebebini ve detaylarını girin..."
              showCount
              maxLength={2000}
            />
          </Form.Item>

          <Row justify="end">
            <Space>
              <Button onClick={() => navigate('/aramalar')}>İptal</Button>
              <Button type="primary" htmlType="submit" loading={saving} icon={<SaveOutlined />}>
                {isEdit ? 'Güncelle' : 'Kaydet'}
              </Button>
            </Space>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default AramaForm;
